import { render, staticRenderFns } from "./consultantPlanDetails.vue?vue&type=template&id=70eeb9f2&scoped=true&"
import script from "./consultantPlanDetails.vue?vue&type=script&lang=js&"
export * from "./consultantPlanDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eeb9f2",
  null
  
)

export default component.exports